'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_RecipeViewer$ScaleBasis() {
}
export { $c_Lmealorama_components_RecipeViewer$ScaleBasis as $c_Lmealorama_components_RecipeViewer$ScaleBasis };
$p = $c_Lmealorama_components_RecipeViewer$ScaleBasis.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_components_RecipeViewer$ScaleBasis;
/** @constructor */
function $h_Lmealorama_components_RecipeViewer$ScaleBasis() {
}
export { $h_Lmealorama_components_RecipeViewer$ScaleBasis as $h_Lmealorama_components_RecipeViewer$ScaleBasis };
$h_Lmealorama_components_RecipeViewer$ScaleBasis.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=mealorama.components.-Recipe-Viewer$-Scale-Basis.js.map
